export type ShareRecipientContactType = 'email' | 'phone';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_ALLOWED_CHARS = /^[+\d\s().-]+$/;
const PHONE_MIN_DIGITS = 7;
const PHONE_MAX_DIGITS = 15;

const isValidEmail = (value: string): boolean => EMAIL_REGEX.test(value);

const isValidPhone = (value: string): boolean => {
    if (!PHONE_ALLOWED_CHARS.test(value)) {
        return false;
    }
    const digits = value.replace(/[^\d]/g, '');
    return digits.length >= PHONE_MIN_DIGITS && digits.length <= PHONE_MAX_DIGITS;
};

export const getShareRecipientAutoComplete = (index: number, contactType: ShareRecipientContactType): string =>
    `section-share${index} ${contactType === 'phone' ? 'tel' : 'email'}`;

export const isValidShareRecipientContact = (value: string, contactType?: ShareRecipientContactType): boolean => {
    const trimmed = value.trim();
    if (!trimmed) {
        return false;
    }
    if (contactType === 'email') {
        return isValidEmail(trimmed);
    }
    if (contactType === 'phone') {
        return isValidPhone(trimmed);
    }
    return isValidEmail(trimmed) || isValidPhone(trimmed);
};

export const getShareRecipientError = (value: string, contactType?: ShareRecipientContactType): string => {
    const trimmed = value.trim();
    if (!trimmed) {
        return '';
    }
    if (isValidShareRecipientContact(trimmed, contactType)) {
        return '';
    }
    if (contactType === 'email') {
        return 'Enter a valid email address';
    }
    if (contactType === 'phone') {
        return 'Enter a valid phone number';
    }
    return 'Enter a valid email or phone number';
};
